<template>
  <Headers> </Headers>
  <div :class="[deviceType, 'progressContainer']">
    <Form
      @submit="onSubmit"
      :validation-schema="schema"
      @invalid-submit="onInvalidSubmit"
    >
      <div :class="[deviceType, 'inner']">
        <div :class="[deviceType, 'content']">
          <div class="line">
            <div :class="[deviceType, 'frame-grey']">
              <div class="remark">
                {{ t("ccOnBoarding.sendBack.remark1") }}
                <br />
                {{ t("ccOnBoarding.sendBack.remark2") }}
              </div>
            </div>

            <div :class="[deviceType, 'separator']">
              <p class="remarkHeader">
                {{ t("ccOnBoarding.uploadDocument.upload") }}
              </p>
              <div class="container2">
                <p
                  class="remarkIncome"
                  v-for="(reason, index) in file.reasonList"
                  :key="index"
                >
                  • {{ reason.remark }}
                </p>

                <div class="uploadFile">
                  <UploadFile
                    :key="uploadFileKey"
                    :id="generateUploadFileId()"
                    @change="uploadFileQuestion"
                    :file-holder="file.sendBackFile1.file"
                    :file-holder-name="file.sendBackFile1.fileName"
                    :file-number="file.sendBackFile1.fileNumber"
                    field="upload2"
                    :uploadFileValidity="uploadFileValidity"
                    :errorDisabledSubmitButton="
                      uploadFileValidity.uploadFile2 == 'EC001'
                    "
                  />
                  <pre class="help" v-if="fileSize">{{
                    t("ccOnBoarding.uploadDocument.fileError")
                  }}</pre>
                  <pre class="help" v-else-if="!upload">{{
                    t("ccOnBoarding.uploadDocument.required")
                  }}</pre>
                  <pre class="help" v-if="encrypted">{{
                    t("ccOnBoarding.uploadDocument.encrypted")
                  }}</pre>
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile2 == 'EC001'"
                    >{{
                      t("ccOnBoarding.uploadDocument.invalidFileConversion")
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile2 == 'EC002'"
                    >{{
                      t("ccOnBoarding.uploadDocument.maliciousFileDetected", {
                        files: uploadFileValidity.maliciousFile2Names.join(", "),
                      })
                    }}</pre
                  >
                  <pre
                    class="help"
                    v-if="uploadFileValidity.uploadFile2 == 'invalidFileType'"
                    >{{ t("ccOnBoarding.uploadDocument.invalidFileType") }}</pre
                  >

                  <div
                    v-if="
                      file.sendBackFile1.fileNumber != 0 &&
                      deviceType != 'Mobile'
                    "
                    style="margin-top: 20px"
                  >
                    <FileList
                      :question="file.sendBackFile1"
                      :uploadFileValidity="uploadFileValidity"
                    ></FileList>
                  </div>
                </div>
                <div
                  v-if="
                    file.sendBackFile1.fileNumber != 0 && deviceType == 'Mobile'
                  "
                  class="margin"
                >
                  <p class="uploaded">
                    {{ t("ccOnBoarding.uploadDocument.uploaded") }}
                  </p>
                  <FileList
                    :question="file.sendBackFile1"
                    :uploadFileValidity="uploadFileValidity"
                  ></FileList>
                </div>
              </div>
            </div>
          </div>
          <div :class="[deviceType, 'buttoncontainer']">
            <div :class="[deviceType, 'left-button']"></div>
            <button
              :class="[deviceType, 'right-button']"
              :disabled="isDisabled"
            >
              {{ t("ccOnBoarding.next") }}
            </button>
          </div>
        </div>
      </div>
    </Form>
    <div v-if="submit" class="overlay">
      <div class="text-center flex-container">
        <p class="loading">
          <b>{{ t("ccOnBoarding.uploadDocument.loading") }}</b>
          <!-- <b>Submit Fail</b> -->
        </p>
        <br />
        <div class="spinner-border" role="status">
          <span class="sr-only">{{
            t("ccOnBoarding.uploadDocument.loading2")
          }}</span>
        </div>
        <br />
        <br />
        <p class="loading">
          <b>{{ t("ccOnBoarding.uploadDocument.loading2") }}</b>
        </p>
        <br />
        <br />
      </div>
    </div>
  </div>

  <PopupMessage
    name="'none'"
    :type="'none'"
    :header="'termsAndCondition'"
    v-if="fail"
    @close-modal="closeTNCModal"
    @submit="onSubmit"
    :popup="true"
  >
  </PopupMessage>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from "vue";
import Headers from "./components/Headers.vue";
import professional from "@/enum/Profesinol";
import i18n from "@/plugin/i18n";
import { Form } from "vee-validate";
import Constants from "@/constants/constants";
import UploadFile from "./components/NewUploadFileComponent.vue";
import FileList from "./components/UploadedFileList.vue";
import type SendBack from "@/interface/FormCCSendBack";
import { pdfRequiresOpenPassword } from "@/utils/pdfRequiresOpenPassword";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import { useRouter } from "vue-router";
import { deviceDetect } from "mobile-device-detect";
import PopupMessage from "./components/PopupMessage.vue";
import type UploadFileValidity from "@/interface/UploadFileValidity";

const deviceType = ref("");
const { t } = i18n.global;
const upload = ref(true);
const submit = ref(false);
const count = ref(0);
const fail = ref(false);

const router = useRouter();

onMounted(() => {
  if (!history.state.responseModel) {
    router.push({
      name: "Acknowledgement",
      query: {
        status: "invalidLink",
      },
    });
  } else {
    file.value.webFormRequestId = history.state.responseModel.webFormRequestId;
    file.value.emailAddress = history.state.responseModel.emailAddress;
    file.value.firstName = history.state.responseModel.firstName;
    file.value.imageFilePath = history.state.responseModel.imageFilePath;
    file.value.mobileNo = history.state.responseModel.mobileNo;
    file.value.product = history.state.responseModel.product;
    file.value.productName = history.state.responseModel.productName;
    file.value.refNo = history.state.responseModel.refNo;
    file.value.reasonList = history.state.responseModel.reasonList;
    file.value.imageFilePathUpload =
      history.state.responseModel.imageFilePathUpload;
  }

  const { isMobile, isTablet } = deviceDetect();

  if (isMobile) {
    deviceType.value = "Mobile";
  } else if (isTablet) {
    deviceType.value = "Tablet";
  } else {
    deviceType.value = "Desktop";
  }
});

// responseModel.value=history.state.
// res.data.responseModel
//List
const titleList = ref([] as string[]);
titleList.value = professional;

let file = ref<SendBack>({
  webFormRequestId: "",
  emailAddress: "",
  firstName: "",
  imageFilePath: "",
  imageFilePathUpload: "",
  mobileNo: "",
  product: "",
  productName: "",
  refNo: "",
  sendBackFile1: {
    file: [],
    fileName: [],
    fileNumber: 0,
    resumeFileNumber: 0,
    resumeDeletedFile: [],
    invalidFile: [],
  },
  reasonList: [
    {
      desc: "",
      remark: "",
    },
  ],
});

const uploadFileValidity = ref<UploadFileValidity>({
  uploadFile1: "",
  uploadFile2: "",
  uploadFile4: "",
  ThirdPartyUploadIdentityFileValidity: "",
  ThirdPartyUploadIncomeFileValidity: "",
  maliciousFile1Names: [],
  maliciousFile2Names: [],
  maliciousFile4Names: [],
});

const closeTNCModal = () => {
  fail.value = false;
};

const isDisabled = computed(() => {
  return file.value.sendBackFile1.fileNumber == 0;
});

const schema = computed(() => {
  return {};
});

const onInvalidSubmit = () => {};

const onSubmit = () => {
  if (uploadFileValidity.value.uploadFile2 == "EC001") {
    return;
  }
  submit.value = true;
  fail.value = false;
  if (
    uploadFileValidity.value.uploadFile2 == "invalidFileType" ||
    uploadFileValidity.value.uploadFile2 == "EC002"
  ) {
    uploadFileValidity.value.uploadFile2 = "";
  }
  MasterService.sendBackSubmit(file.value)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.responseModel.status == "ED") {
          submit.value = false;
          fail.value = true;
        } else if (res.data.responseModel.status == "EC001") {
          submit.value = false;
          uploadFileValidity.value.uploadFile2 = res.data.responseModel.status;

          if (
            res.data.responseModel.documentNameDTO.sendBack &&
            res.data.responseModel.documentNameDTO.sendBack.sendBackFileName &&
            res.data.responseModel.documentNameDTO.sendBack.sendBackFileName
              .length != 0
          ) {
            for (
              let i = 0;
              i <
              res.data.responseModel.documentNameDTO.sendBack.sendBackFileName
                .length;
              i++
            ) {
              for (
                let j = 0;
                j < file.value.sendBackFile1.fileName.length;
                j++
              ) {
                if (
                  res.data.responseModel.documentNameDTO.sendBack
                    .sendBackFileName[i] == file.value.sendBackFile1.fileName[j]
                ) {
                  file.value.sendBackFile1.invalidFile[j] = true;
                }
              }
            }
          }

          return;
        } // Malicious File
        else if (res.data.responseModel.status == "EC002") {
          submit.value = false;

          if (
            res.data.responseModel.documentNameDTO.sendBack &&
            res.data.responseModel.documentNameDTO.sendBack.sendBackFileName &&
            res.data.responseModel.documentNameDTO.sendBack.sendBackFileName
              .length != 0
          ) {
            const deletedNames: string[] = [];
            for (
              let i = 0;
              i <
              res.data.responseModel.documentNameDTO.sendBack.sendBackFileName
                .length;
              i++
            ) {
              for (
                let j = file.value.sendBackFile1.fileName.length - 1;
                j >= 0;
                j--
              ) {
                if (
                  res.data.responseModel.documentNameDTO.sendBack
                    .sendBackFileName[i] == file.value.sendBackFile1.fileName[j]
                ) {
                  deletedNames.push(file.value.sendBackFile1.fileName[j]);
                  file.value.sendBackFile1.fileName.splice(j, 1);
                  file.value.sendBackFile1.file.splice(j, 1);
                  file.value.sendBackFile1.fileNumber =
                    file.value.sendBackFile1.fileName.length;
                }
              }
            }
            if (deletedNames.length > 0) {
              uploadFileValidity.value.uploadFile2 = "EC002";
              uploadFileValidity.value.maliciousFile2Names = deletedNames;
            }
          }
        } else {
          router.push({
            name: "Acknowledgement",
            query: {
              status: "sendBack",
              refNo: file.value.refNo,
            },
          });
        }
      }
    })
    .catch(() => {
      submit.value = false;
      count.value += 1;
      fail.value = true;
    });
};

const generateUploadFileId = () => {
  const fileNameLength = file.value.sendBackFile1.fileName.length;
  return `uploadFileQuestion1N${fileNameLength}`;
};
const uploadFileKey = ref(0);
const fileSize = ref(false);
const encrypted = ref(false);

const uploadFileQuestion = async () => {
  fileSize.value = false;
  encrypted.value = false;
  const fileId = generateUploadFileId();
  const fileInput = (document.getElementById(fileId) as HTMLInputElement)
    .files?.[0];
  uploadFileKey.value += 1;
  if (fileInput != null) {
    const formData = new FormData();
    formData.append("file", fileInput);

    const maxSizeBytes = Constants.FILE_SIZE;

    if (fileInput.size > maxSizeBytes) {
      fileSize.value = true;
    } else {
      try {
        if (fileInput.name.toLowerCase().endsWith(".pdf")) {
          const buffer = await fileInput.arrayBuffer();
          if (await pdfRequiresOpenPassword(buffer)) {
            encrypted.value = true;
          } else {
            encrypted.value = false;
            upload.value = true;
            file.value.sendBackFile1.fileName.push(fileInput.name);
            file.value.sendBackFile1.fileNumber =
              file.value.sendBackFile1.fileName.length;
            file.value.sendBackFile1.file.push(formData);
          }
        } else {
          // For non-PDF files, proceed with the upload
          encrypted.value = false;
          upload.value = true;
          file.value.sendBackFile1.fileName.push(fileInput.name);
          file.value.sendBackFile1.fileNumber =
            file.value.sendBackFile1.fileName.length;
          file.value.sendBackFile1.file.push(formData);
        }
      } catch {
        encrypted.value = false;
      }
    }
  }
};

watch(
  () => count.value,
  (newValue) => {
    if (newValue > 3) {
      router.push({
        name: "Acknowledgement",
        query: {
          status: "denied",
          refNo: file.value.refNo,
        },
      });
    }
  },
);
</script>

<style scoped>
.progressContainer {
  max-width: 1440px;
  margin: auto;
  padding: 4% 8%;
  background: #fff;
}

.remarkHeader {
  margin-bottom: 8px;
  text-align: left;
  color: rgba(0, 0, 0, 0.87);
  font: 500 16px/130% "Outfit";
  position: relative;
  align-self: stretch;
}

.remarkIncome {
  margin-bottom: 5px;
  text-align: left;
  color: rgba(0, 0, 0, 0.38);
  font: 500 14px/130% "Outfit";
  position: relative;
  align-self: stretch;
}

.remarkIncomeContainer {
  margin-bottom: 16px;
}

.content {
  margin-top: 40px;
  padding: 0 8%;
}

.help {
  color: red;
  margin-bottom: 0px;
  font:
    400 16px/130% "Outfit",
    sans-serif;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.separator {
  margin-bottom: 32px;
  margin-top: 32px;
  padding: 0 20px;
}

.right-button {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background-image: var(
    --gradient-set-active,
    linear-gradient(120deg, #7653ff -4.72%, #8e4eff -3.32%, #ea27c2 45.42%)
  );
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.left-button {
  flex: 0 0 25%;
}

.right-button:disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 25%;
}

.line {
  border-bottom: 1px solid #e4e4e4;
}

.buttoncontainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
}

.left-button {
  flex: 0 0 15%;
}

.frame-grey,
.frame-grey * {
  box-sizing: border-box;
}
.frame-grey {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 24px 32px 24px 32px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.frame-grey:is(.Mobile) {
  padding: 10px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}

.remark {
  color: var(--web-black-medium, #757575);
  text-align: left;
  font-family: var(--subtitle-2-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-2-font-size, 14px);
  line-height: var(--subtitle-2-line-height, 130%);
  font-weight: var(--subtitle-2-font-weight, 500);
  position: relative;
  flex: 1;
}

.uploadFile {
  border-radius: 8px;
  border-style: solid;
  border-color: #e4e4e4;
  border-width: 1px;
  padding: 18px 24px;
  margin-top: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 9999;
  will-change: transform, opacity;
  transform: translateZ(0);
  overflow-y: hidden;
  transition: top 0.3s;
}

.loading {
  margin-bottom: 0;
  font-family: "Outfit";
  color: white;
}

.spinner-border {
  width: 5rem;
  height: 5rem;
  color: white;
}

.flex-container {
  left: 0;
  margin: auto;
  position: absolute;
  text-align: center;
  top: 35%;
  right: 30%;
  left: 30%;
}

.margin {
  margin-top: 20px;
}

@media (max-width: 700px) {
  .buttoncontainer:is(.Desktop, .Tablet) {
    /* flex-wrap: wrap; */
    gap: 10px;
  }

  .left-button:is(.Desktop, .Tablet) {
    flex: 0 0 30%;
  }

  .right-button:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .right-button:disabled:is(.Desktop, .Tablet) {
    flex: 0 0 68%;
  }

  .separator:is(.Desktop, .Tablet) {
    margin-bottom: 40px;
  }
}

.inner:is(.Mobile) {
  padding: 20px 20px 0 20px;
}

.content:is(.Mobile),
.separator:is(.Mobile) {
  padding: 0;
}

.uploaded {
  margin-bottom: 15px;
  color: var(--black-high-87, rgba(0, 0, 0, 0.87));
  text-align: left;
  font-family: var(--subtitle-1-medium-font-family, "Outfit", sans-serif);
  font-size: var(--subtitle-1-medium-font-size, 16px);
  line-height: var(--subtitle-1-medium-line-height, 130%);
  font-weight: var(--subtitle-1-medium-font-weight, 500);
  position: relative;
  flex: 1;
}

.progressContainer:is(.Mobile) {
  max-width: 1440px;
  margin: auto;
  padding: 0;
  background: #fff;
}

.buttoncontainer:is(.Mobile) {
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 20px 20px 20px;
}

.left-button:is(.Mobile) {
  flex: 0 0 30%;
  /* display: none; */
}

.right-button:is(.Mobile) {
  flex: 0 0 68%;
}

.right-button:is(.Mobile):disabled {
  width: 100%;
  height: 40px;
  padding: 8px 24px;
  border-radius: 24px;
  border: none;
  background: #dedede;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  flex: 0 0 68%;
}
</style>
